import React from 'react';
import lineModules from '../../../../core/components/lineModules';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import { FaPaintBrush } from 'react-icons/fa';

const UpdateEventTheme: React.FC = () => {

    const { configuration } = useConfiguration();

    const formSchemaUpdate = {
        theme: {
            model: 'jsonList',
            type: 'text',
            name: 'theme',
            label: 'Personalização',
            list: [
                { label: 'Fundo da Programação', name: 'program_background' },
                { label: 'Fundo da linha da Programação', name: 'line_background' },
                { label: 'Template de programação', name: 'program_template' },

                { label: 'Cor do Título da Programação', name: 'program_title_color' },
                { label: 'Fundo dos palestrantes', name: 'speaker_background' },
                { label: 'Cor do Título dos Palestrantes', name: 'speaker_title_color' },
                { label: 'Cor do Texto dos Palestrantes', name: 'speaker_text_color' },
                { label: 'Fundo do botão', name: 'button_background' },
                { label: 'Cor do botão', name: 'button_color' },

            ],
        },
        landing_page: {
            model: 'jsonInputList',
            type: 'text',
            name: 'landing_page',
            label: 'Configuração da Landing Page',
            show: ['reference'],
            list: [
                { label: 'Referência', name: 'reference', type: 'input' },
                { label: 'Hash', name: 'hash', type: 'input' },


            ]
        }
    };

    const endpoint = '/events';
    return lineModules.updateUnique({
        lineData: { _id: configuration?.current_event_id_response?._id?.toString() },
        title: 'Personalizar Landing Page',
        formSchema: formSchemaUpdate,
        validationSchema: {},
        endpoint,
        Icon: FaPaintBrush
    })

}

export default UpdateEventTheme;